import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as fromRoot from '@app/reducers';
import { select, Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { AccountActions } from '../../actions';
import { TokenService } from '../../services/token.service';

@Injectable({
  providedIn: 'root'
})
export class IsPremiumTokenValidGuard  {

  constructor(
    private store$: Store<fromRoot.State>,
    private tokenService: TokenService
  ) {
  }

  canActivate(): Observable<boolean> {
    return this.isPremiumTokenValid().pipe(map((accountIsValid: boolean) => {
      return accountIsValid;
    }));
  }

  isPremiumTokenValid(): Observable<boolean> {
    const isPremiumTokenValid$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      select(fromRoot.getToken),
      distinctUntilChanged(),
      takeUntil(isPremiumTokenValid$),
    ).subscribe((token: string) => {
      if (token) {
        if (this.tokenService.isTokenExpired(token)) {
          this.store$.dispatch(AccountActions.refreshToken());
        } else {
          this.store$.dispatch(AccountActions.getProfileInformation());
          isPremiumTokenValid$.next(true);
        }
      }
    });
    return isPremiumTokenValid$.asObservable();
  }
}
